// --- smooth scroll --------------

// lenis smooth scroll
// const lenis = new Lenis({
//   smoothWheel: true, // Smooth wheel behavior
//   smoothTouch: false, // Disable smooth touch scrolling (if needed)
//   normalizeWheel: true, // Normalize wheel events
//   // Ignore elements with the class 'scroll-section' (or any other class you use)
//   ignore: (el) => el.classList.contains("scroll-section"),
// });

// lenis.on("scroll", ScrollTrigger.update);
// gsap.ticker.add((time) => {
//   lenis.raf(time * 700);
// });

// gsap.ticker.lagSmoothing(0);

// --- smooth scroll --------------
//{% comment %} =============== Low Power mode code ============ {% endcomment %}
 
  document.addEventListener('DOMContentLoaded', () => {
    const videos = document.querySelectorAll('video');
 
    if (!videos.length) return;
 
    const tryPlay = (video) => {
      if (video.paused) {
        const p = video.play();
        if (p !== undefined) {
          p.catch(() => {});
        }
      }
    };
 
    // Initial attempt
    videos.forEach((v) => tryPlay(v));
 
    // iOS-approved user interaction fallback
    const interactionEvents = ['touchstart', 'click', 'pointerdown'];
 
    const onUserInteraction = () => {
      videos.forEach((v) => tryPlay(v));
      interactionEvents.forEach((evt) => document.removeEventListener(evt, onUserInteraction));
    };
 
    interactionEvents.forEach((evt) => document.addEventListener(evt, onUserInteraction, { once: true }));
 
    // Resume if Safari pauses it (common in Low Power Mode)
    videos.forEach((video) => {
      video.addEventListener('pause', () => {
        setTimeout(() => tryPlay(video), 500);
      });
    });
  });
 
//{% comment %} =============== Low Power mode code ============ {% endcomment %}

// image-new-slider
document.addEventListener("DOMContentLoaded",()=>{
const target = document.querySelector("product-recommendations");

if (target) {
  const observer = new MutationObserver((mutations,obs) => {
    for (const mutation of mutations) {
        obs.disconnect();
      if (mutation.type === "childList") {
            document.querySelectorAll('.productSwiper').forEach((slider) => {
            new Swiper(slider, {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 0,
                allowTouchMove: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                    dynamicBullets: true,
                },
                navigation: {
                nextEl: slider.querySelector('.swiper-button-next'),
                prevEl: slider.querySelector('.swiper-button-prev'),
                },
            });
        });
        break;
      }
    }
  });

  observer.observe(target, {
    childList: true, // watch children add/remove
  });
}
const collectionProducts = document.querySelector(".active-facets.active-facets-desktop");
if (collectionProducts) {
  const observer = new MutationObserver((mutations,obs) => {
    for (const mutation of mutations) {
            document.querySelectorAll('.productSwiper').forEach((slider) => {
            new Swiper(slider, {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 0,
                allowTouchMove: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                    dynamicBullets: true,
                },
                navigation: {
                nextEl: slider.querySelector('.swiper-button-next'),
                prevEl: slider.querySelector('.swiper-button-prev'),
                },
            });
        });
        break;
    }
  });

  observer.observe(collectionProducts, {
    childList: true, // watch children add/remove,
    subtree: true,
  });
}


document.querySelectorAll('.productSwiper').forEach((slider) => {
      new Swiper(slider, {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 0,
  allowTouchMove: true, // ✅ enable touch
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    dynamicBullets: true,
  },
  navigation: {
    nextEl: slider.querySelector('.swiper-button-next'),
    prevEl: slider.querySelector('.swiper-button-prev'),
  },
});

    });

    // for product-rec

});



// image-new-slider

// ------------ Header Transform --------------

// let prevScroll = 0 ;
// document.addEventListener("scroll",()=>{
//   if(innerWidth > 1100){
//     curScroll = scrollY;
//     if(curScroll>prevScroll){
//       document.querySelector(".main-header").classList.add("to-transform");
//     }else{
//       document.querySelector(".main-header").classList.remove("to-transform");
//     }
//     prevScroll = curScroll;
//   }
// })

// ------------ Header Transform --------------

// -------- weather and city live -----------------

// const sunny = `<svg viewBox="0 0 48 48" id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><defs><style>.cls-1{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;}</style></defs><path class="cls-1" d="M24,13A11,11,0,1,1,13,24,11,11,0,0,1,24,13Z"></path><line class="cls-1" x1="24" y1="3.5" x2="24" y2="9.61"></line><line class="cls-1" x1="38.5" y1="9.5" x2="34.18" y2="13.82"></line><line class="cls-1" x1="44.5" y1="24" x2="38.39" y2="24"></line><line class="cls-1" x1="38.5" y1="38.5" x2="34.18" y2="34.18"></line><line class="cls-1" x1="24" y1="44.5" x2="24" y2="38.39"></line><line class="cls-1" x1="9.5" y1="38.5" x2="13.82" y2="34.18"></line><line class="cls-1" x1="3.5" y1="24" x2="9.61" y2="24"></line><line class="cls-1" x1="9.5" y1="9.5" x2="13.82" y2="13.82"></line></g></svg>`;

// const rainy = `<svg id="Group_12" data-name="Group 12" xmlns="http://www.w3.org/2000/svg" width="21.837" height="21.317" viewBox="0 0 21.837 21.317">
//       <path id="Path_29" data-name="Path 29" d="M20.8,11.959a4.679,4.679,0,0,0-4.679-4.679h-.093a4.681,4.681,0,0,0-4.582,4.472.52.52,0,0,1-1.039-.046,5.721,5.721,0,0,1,5.162-5.44,4.733,4.733,0,0,0,.032-.546,4.679,4.679,0,1,0-9.265.936.52.52,0,0,1-.51.624h-.1a4.68,4.68,0,0,0-3.342,7.955.52.52,0,1,1-.742.727,5.718,5.718,0,0,1,3.591-9.7C5.209,6.083,5.2,5.9,5.2,5.719a5.719,5.719,0,0,1,11.439,0c0,.183-.011.364-.027.542a5.719,5.719,0,0,1-.492,11.416h-1.56a.52.52,0,1,1,0-1.04h1.56A4.679,4.679,0,0,0,20.8,11.959Z"></path>
//       <path id="Path_30" data-name="Path 30" d="M1.8,19.174a.52.52,0,0,1,.9.52l-.488.845a.52.52,0,1,1-.9-.52Zm1.951-3.38a.52.52,0,0,1,.9.52L3.681,18a.52.52,0,0,1-.9-.52ZM5.219,13.26a.52.52,0,0,1,.9.52l-.487.845a.52.52,0,0,1-.9-.52Z" transform="translate(0.05 0.518)"></path>
//       <path id="Path_31" data-name="Path 31" d="M5.557,19.174a.52.52,0,0,1,.9.52l-.488.845a.52.52,0,1,1-.9-.52Zm1.951-3.38a.52.52,0,0,1,.9.52L7.434,18a.52.52,0,0,1-.9-.52ZM8.972,13.26a.52.52,0,0,1,.9.52l-.487.845a.52.52,0,0,1-.9-.52Z" transform="translate(0.199 0.518)"></path>
//       <path id="Path_32" data-name="Path 32" d="M9.557,19.174a.52.52,0,0,1,.9.52l-.488.845a.52.52,0,1,1-.9-.52Zm1.951-3.38a.52.52,0,0,1,.9.52L11.434,18a.52.52,0,0,1-.9-.52Zm1.464-2.535a.52.52,0,1,1,.9.52l-.487.845a.52.52,0,0,1-.9-.52Z" transform="translate(0.359 0.518)"></path>
//     </svg>`;

// const thunder = `<svg version="1.1" id="Uploaded to svgrepo.com" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="800px" height="800px" viewBox="0 0 32 32" xml:space="preserve" fill="#000000">
// <g id="SVGRepo_bgCarrier" stroke-width="0"/>
// <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/>
// <g id="SVGRepo_iconCarrier"> <style type="text/css"></style> <g> <g> <path class="open_een" d="M22.469,7.085C21.05,4.556,18.414,3,15.5,3c-4.074,0-7.456,3.048-7.933,7.037 C7.373,10.012,7.185,10,7,10c-2.757,0-5,2.243-5,5s2.243,5,5,5h1.5C8.776,20,9,19.776,9,19.5S8.776,19,8.5,19H7 c-2.206,0-4-1.794-4-4s1.794-4,4-4c0.282,0,0.578,0.037,0.906,0.113c0.145,0.035,0.296,0.001,0.414-0.088 c0.118-0.09,0.191-0.227,0.198-0.375C8.703,6.921,11.769,4,15.5,4c2.66,0,5.056,1.482,6.254,3.869 c0.102,0.203,0.328,0.311,0.554,0.264C25.851,7.356,29,10.079,29,13.5c0,3.032-2.467,5.5-5.5,5.5h-6.929l0.924-6.934 c0.032-0.239-0.111-0.466-0.339-0.541c-0.229-0.079-0.479,0.022-0.594,0.233l-5.5,10c-0.085,0.155-0.083,0.344,0.008,0.496 c0.09,0.151,0.253,0.245,0.43,0.245h1.965l-0.464,6.967c-0.015,0.23,0.129,0.441,0.35,0.511C13.4,29.992,13.45,30,13.5,30 c0.172,0,0.336-0.089,0.429-0.243l4.5-7.5c0.142-0.236,0.065-0.544-0.171-0.686c-0.238-0.144-0.544-0.064-0.686,0.172 l-3.435,5.724l0.362-5.434c0.009-0.138-0.04-0.273-0.134-0.375C14.271,21.558,14.138,21.5,14,21.5h-1.654l3.806-6.92l-0.647,4.854 c-0.037,0.274,0.156,0.525,0.43,0.562c0.023,0.003,0.044-0.004,0.066-0.004V20h7.5c3.584,0,6.5-2.916,6.5-6.5 C30,9.578,26.496,6.43,22.469,7.085z"/> </g> <g> <path class="open_een" d="M22.469,7.085C21.05,4.556,18.414,3,15.5,3c-4.074,0-7.456,3.048-7.933,7.037 C7.373,10.012,7.185,10,7,10c-2.757,0-5,2.243-5,5s2.243,5,5,5h1.5C8.776,20,9,19.776,9,19.5S8.776,19,8.5,19H7 c-2.206,0-4-1.794-4-4s1.794-4,4-4c0.282,0,0.578,0.037,0.906,0.113c0.145,0.035,0.296,0.001,0.414-0.088 c0.118-0.09,0.191-0.227,0.198-0.375C8.703,6.921,11.769,4,15.5,4c2.66,0,5.056,1.482,6.254,3.869 c0.102,0.203,0.328,0.311,0.554,0.264C25.851,7.356,29,10.079,29,13.5c0,3.032-2.467,5.5-5.5,5.5h-6.929l0.924-6.934 c0.032-0.239-0.111-0.466-0.339-0.541c-0.229-0.079-0.479,0.022-0.594,0.233l-5.5,10c-0.085,0.155-0.083,0.344,0.008,0.496 c0.09,0.151,0.253,0.245,0.43,0.245h1.965l-0.464,6.967c-0.015,0.23,0.129,0.441,0.35,0.511C13.4,29.992,13.45,30,13.5,30 c0.172,0,0.336-0.089,0.429-0.243l4.5-7.5c0.142-0.236,0.065-0.544-0.171-0.686c-0.238-0.144-0.544-0.064-0.686,0.172 l-3.435,5.724l0.362-5.434c0.009-0.138-0.04-0.273-0.134-0.375C14.271,21.558,14.138,21.5,14,21.5h-1.654l3.806-6.92l-0.647,4.854 c-0.037,0.274,0.156,0.525,0.43,0.562c0.023,0.003,0.044-0.004,0.066-0.004V20h7.5c3.584,0,6.5-2.916,6.5-6.5 C30,9.578,26.496,6.43,22.469,7.085z"/> </g> </g> </g>
// </svg>`
    
// function renderWeather(condCode,cityName,temp,condition){

//     const weatherIcon = document.querySelector(".weather-logo");

//     if (condCode == 1000) {
//       weatherIcon.innerHTML = sunny;
//     } else if (condCode >= 1183 && condCode <= 1249) {
//       weatherIcon.innerHTML = rainy;
//     } else if (condCode >= 1273 && condCode <= 1282) {
//       weatherIcon.innerHTML = thunder;
//     }

//   document.querySelectorAll(".weather-city").forEach((el)=>{el.textContent = cityName+ " city"});
//     document.querySelectorAll(".weather-temp").forEach((el)=>{el.textContent = `${temp}° ${condition}`});
//     document.querySelectorAll(".header-weather").forEach((el)=>{el.setAttribute("style","opacity:1")});
// }

// async function fetchWeatherByCity(city) {
//   const apiKey = 'c6d7740ac40341c09c3125625251110';
//   const weatherUrl = `https://api.weatherapi.com/v1/current.json?key=${apiKey}&q=${encodeURIComponent(city)}`;
  
//   try {
//     const response = await fetch(weatherUrl);
//     const data = await response.json();
//     const condCode = data.current.condition.code;
//     const cityName = data.location.name.toUpperCase();
//     // const temp = Math.ceil(data.current.temp_f);  // fahrenheit
//     const temp = Math.ceil(data.current.temp_c);
//     const condition = data.current.condition.text;
//     sessionStorage.setItem("condCode",condCode);
//     sessionStorage.setItem("cityName",cityName);
//     sessionStorage.setItem("temp",temp);
//     sessionStorage.setItem("condition",condition);

//     renderWeather(condCode,cityName,temp,condition);

//   } catch (error) {
//     console.error('Weather fetch error:', error);
//   }
// }

// async function getUserCityAndWeather() {
//   try {
//     const geoRes = await fetch('https://ipapi.co/json/');
//     const geoData = await geoRes.json();
//     const userCity = geoData.city;
    
//     if (userCity) {
//       fetchWeatherByCity(userCity);
//     }
//   } catch (error) {
//     console.error('Geolocation error:', error);
//   }
// }
// if(sessionStorage.getItem("cityName")){
//     const condCode = sessionStorage.getItem("condCode");
//     const cityName = sessionStorage.getItem("cityName");
//     const temp = sessionStorage.getItem("temp");
//     const condition = sessionStorage.getItem("condition");
//     renderWeather(condCode,cityName,temp,condition);
// }else{
//   getUserCityAndWeather();
// }

// -------- weather and city live -----------------



// =================== Draggable JS ========================


function enableLeftClickDragScroll(container) {
  if (!container) return;

  let isDragging = false;
  let dragStarted = false;
  let startX = 0;
  let scrollStart = 0;
  const dragThreshold = 5;

  container.addEventListener("mousedown", (e) => {
    if (e.button !== 0) return;
    isDragging = true;
    dragStarted = false;
    startX = e.pageX;
    scrollStart = container.scrollLeft;
    container.classList.add("is-dragging");
    e.preventDefault();
  });

  container.addEventListener("mousemove", (e) => {
    if (!isDragging) return;
    const deltaX = e.pageX - startX;

    if (!dragStarted && Math.abs(deltaX) > dragThreshold) {
      dragStarted = true;
    }

    if (dragStarted) {
      container.scrollLeft = scrollStart - deltaX;
    }
  });

  container.addEventListener("mouseup", () => {
    isDragging = false;
    container.classList.remove("is-dragging");
  });

  container.addEventListener("mouseleave", () => {
    isDragging = false;
    container.classList.remove("is-dragging");
  });

  container.addEventListener("click", (e) => {
    if (dragStarted) {
      e.preventDefault();
      e.stopPropagation();
      dragStarted = false;
    }
  });

  container.classList.add("is-draggable");
}

function waitForElementAndInit(selector) {
  // Initialize any that already exist
  document.querySelectorAll(selector).forEach(el => {
    if (!el._dragInitialized) {
      enableLeftClickDragScroll(el);
      el._dragInitialized = true;
    }
  });

  // Observe future additions
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;

        if (node.matches(selector) && !node._dragInitialized) {
          enableLeftClickDragScroll(node);
          node._dragInitialized = true;
        }

        // Check descendants too
        node.querySelectorAll?.(selector)?.forEach((el) => {
          if (!el._dragInitialized) {
            enableLeftClickDragScroll(el);
            el._dragInitialized = true;
          }
        });
      });
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

document.addEventListener("DOMContentLoaded", () => {
  // ===============================================
  // ADD CLASS OR ID OF CONTAINER TO SCROLL [ DEV-03 ]
  // ===============================================
  const scrollSelectors = [".product-grid",".cust-collection-boxes-content ul",".tab-collection-grid",".gallery_hero_container"];

  scrollSelectors.forEach(selector => {
    waitForElementAndInit(selector);
  });
});

// --------- Draggable JS ---------


// <!-- // product accordion start -->

document.addEventListener("DOMContentLoaded",()=>{
(function() {
    const initializeAccordion = () => {
        const accordionItemHeaders = document.querySelectorAll(".accordion-item-header");
        // Remove previous event listeners to prevent stacking
        accordionItemHeaders.forEach(header => {
          header.removeEventListener("click", toggleAccordion);
        });

        if (accordionItemHeaders.length > 0) {
            accordionItemHeaders.forEach((accordionItemHeader) => {
                accordionItemHeader.addEventListener("click", toggleAccordion);
            });
        }
    };

    const toggleAccordion = (event) => {
        const accordionItemHeader = event.currentTarget;
        const currentlyActiveAccordionItemHeader = document.querySelector(".accordion-item-header.active");

        if (currentlyActiveAccordionItemHeader && currentlyActiveAccordionItemHeader !== accordionItemHeader) {
            currentlyActiveAccordionItemHeader.classList.remove("active");
            currentlyActiveAccordionItemHeader.nextElementSibling.style.maxHeight = 0;
        }

        accordionItemHeader.classList.toggle("active");
        const accordionItemBody = accordionItemHeader.nextElementSibling;
        if (accordionItemHeader.classList.contains("active")) {
            accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + "px"; // Set max-height to scroll height
        } else {
            accordionItemBody.style.maxHeight = 0;
        }
    };

    // Call the function to initialize the accordion
    initializeAccordion();
})();
})

// <!-- // product accordion end -->


// ===========size chart================


  window.openSizeChart = function () {
    const charts = document.querySelectorAll('.overlay');
    if (charts.length) {
      charts[charts.length - 1].classList.toggle('active');
    }
  };

  // Observe for any new overlays added dynamically (for AJAX product modals, etc.)
  new MutationObserver(() => {
    document.querySelectorAll('.overlay:not([data-init])').forEach(initSizeChart);
  }).observe(document.body, { childList: true, subtree: true });

  // Initialize a single overlay
  function initSizeChart(overlay) {
    overlay.setAttribute('data-init', 'true');

    const closeBtn = overlay.querySelector('.x-btn-size');
    const chartBox = overlay.querySelector('.main-size-chart');

    // Close when clicking X
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        overlay.classList.remove('active');
      });
    }

    // Close when clicking outside content
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) {
        overlay.classList.remove('active');
      }
    });
  }

  // Run immediately for overlays already in DOM
  document.querySelectorAll('.overlay:not([data-init])').forEach(initSizeChart);

  // Optional: Close overlay if scrolling away from product area
  window.addEventListener('scroll', () => {
    const product = document.querySelector('.product');
    let shouldClose = false;

    if (product) {
      const rect = product.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) {
        shouldClose = true;
      }
    } else {
      shouldClose = true;
    }

    if (shouldClose) {
      document.querySelectorAll('.overlay.active').forEach((overlay) => {
        overlay.classList.remove('active');
      });
    }
  });


  // ===========size chart================



  // -------- mobile menu open/close ----

  // ------------ mobile menu x design ----------------

// const toggleBtn = document.querySelector(".toggle-btn-d");
// const mobMenuBox = document.querySelector(".mob-menu-box");

// toggleBtn.addEventListener("click", () => {
//   toggleBtn.classList.toggle("active");
//   mobMenuBox.classList.toggle("active");
// });

// ----when desktop menu also add
const toggleButtons = document.querySelectorAll(".toggle-btn-d");
const mainHeader = document.querySelector(".main-header");
const body = document.body;

toggleButtons.forEach(button => {
  button.addEventListener("click", () => {
    const targetClass = button.getAttribute("data-target");
    const targetMenu = document.querySelector(`.${targetClass}`);

    button.classList.toggle("active");
    targetMenu.classList.toggle("active");

    // Remove class when menu is opening
    if (targetMenu.classList.contains("active")) {
      mainHeader.classList.remove("to-transform");
      body.classList.add("scroll-stop");
    } else {
      body.classList.remove("scroll-stop");
    }
  });
});

// Desktop backdrop click
// const deskMenuBox = document.querySelector(".desk-menu-box");
// if (deskMenuBox) {
//   deskMenuBox.addEventListener("click", (e) => {
//     if (e.target === deskMenuBox) {
//       deskMenuBox.classList.remove("active");
//       const button = document.querySelector(`.toggle-btn-d[data-target="desk-menu-box"]`);
//       if (button) button.classList.remove("active");
//       if (mainHeader) mainHeader.classList.remove("to-transform");
//       lenis.start();
//     }
//   });
// }



document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.super-main-header');
  const menuWrapper = document.querySelector('.menu-main-wrapper');
  const triggers = document.querySelectorAll('.cust-desktop-menu[data-menu]');
  const menus = menuWrapper?.querySelectorAll('[data-menu-content]');

  if (!header || !menuWrapper || !menus.length) return;

  function closeMenu() {
    menuWrapper.classList.remove('active');

    triggers.forEach(trigger => trigger.classList.remove('active'));
    menus.forEach(menu => menu.classList.remove('active'));
  }

  triggers.forEach(trigger => {
    trigger.addEventListener('mouseenter', function () {
      const target = menuWrapper.querySelector(
        `[data-menu-content="${trigger.dataset.menu}"]`
      );

      if (!target) return;

      triggers.forEach(item => item.classList.toggle('active', item === trigger));
      menus.forEach(menu => menu.classList.toggle('active', menu === target));

      menuWrapper.classList.add('active');
    });
  });

  menuWrapper.addEventListener('mouseleave', closeMenu);

  header.addEventListener('mouseleave', function (event) {
    if (event.relatedTarget && menuWrapper.contains(event.relatedTarget)) return;
    closeMenu();
  });

  document.querySelectorAll(
    '.header-left.desktop li:not(:has(.cust-desktop-menu)) a'
  ).forEach(link => {
    link.addEventListener('mouseenter', closeMenu);
  });
});








// Mobile backdrop click
const mobMenuBox = document.querySelector(".mob-menu-box");
if (mobMenuBox) {
  mobMenuBox.addEventListener("click", (e) => {
    if (e.target === mobMenuBox) {
      mobMenuBox.classList.remove("active");
      const button = document.querySelector(`.toggle-btn-d[data-target="mob-menu-box"]`);
      if (button) button.classList.remove("active");
      if (mainHeader) mainHeader.classList.remove("to-transform");
      lenis.start();
    }
  });
}



// ------------ mobile menu x design ------------------------

  // -------- mobile menu open/close ----

  // ------- accordion for quickadd -------

document.addEventListener("DOMContentLoaded", () => {
    new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            mutation.addedNodes.forEach(node => {
                node.nodeType === 1 && node.classList.contains("quick-add-modal") && checkOpenModal(node)
            }
            )
        }
        )
    }
    ).observe(document.body, {
        childList: !0,
        subtree: !0
    }),
    document.querySelectorAll(".quick-add-modal").forEach(target => {
        checkOpenModal(target)
    }
    )
}
);
function checkOpenModal(target) {
    new MutationObserver(mutationsList => {
        for (const mutation of mutationsList)
            if (mutation.type === "attributes" && mutation.attributeName === "open" && target.hasAttribute("open")) {
              (function() {
                  const initializeAccordion = () => {
                      const accordionItemHeaders = document.querySelectorAll(".accordion-item-header");
                      // Remove previous event listeners to prevent stacking
                      accordionItemHeaders.forEach(header => {
                        header.removeEventListener("click", toggleAccordion);
                      });

                      if (accordionItemHeaders.length > 0) {
                          accordionItemHeaders.forEach((accordionItemHeader) => {
                              accordionItemHeader.addEventListener("click", toggleAccordion);
                          });
                      }
                  };

                  const toggleAccordion = (event) => {
                      const accordionItemHeader = event.currentTarget;
                      const currentlyActiveAccordionItemHeader = document.querySelector(".accordion-item-header.active");

                      if (currentlyActiveAccordionItemHeader && currentlyActiveAccordionItemHeader !== accordionItemHeader) {
                          currentlyActiveAccordionItemHeader.classList.remove("active");
                          currentlyActiveAccordionItemHeader.nextElementSibling.style.maxHeight = 0;
                      }

                      accordionItemHeader.classList.toggle("active");
                      const accordionItemBody = accordionItemHeader.nextElementSibling;
                      if (accordionItemHeader.classList.contains("active")) {
                          accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + "px"; // Set max-height to scroll height
                      } else {
                          accordionItemBody.style.maxHeight = 0;
                      }
                  };

                  // Call the function to initialize the accordion
                  initializeAccordion();
              })();
            }
    }
    ).observe(target, {
        attributes: !0,
        attributeFilter: ["open"]
    })
}

  // ------- accordion for quickadd -------


  // ------- PDP Price Clone -------
document.addEventListener("DOMContentLoaded", () => {
  const pdpInfo = document.querySelector(".product__info-container");
  if (!pdpInfo) {
    return;
  }
  const curPrice = pdpInfo.querySelector(".price-item.price-item--sale").textContent.trim()
  let lastPrice = curPrice;
  const observer = new MutationObserver(() => {
    const newPrice = document.querySelector(".price-item.price-item--sale").textContent.trim();
    if (newPrice !== lastPrice) {
      document.querySelector(".pdp-clone-price").textContent = newPrice;
      lastPrice = newPrice;
    }
  });
  observer.observe(pdpInfo, {
    characterData: true,
    childList: true,
    subtree: true,
  });
});
  // ------- PDP Price Clone -------


  // ------ desktop menu accordion -----
  function initMenuTabs() {

  document.querySelectorAll('[data-tab-group]').forEach(group => {

    const tabs = group.querySelectorAll('ul li');
    const contents = group.querySelectorAll('[data-content]');

    tabs.forEach(tab => {

      tab.addEventListener('click', () => {

        const target = tab.dataset.tab;

        tabs.forEach(t => t.classList.remove('active'));
        contents.forEach(c => c.classList.remove('active'));

        tab.classList.add('active');

        const activeContent = group.querySelector('[data-content="' + target + '"]');
        if(activeContent){
          activeContent.classList.add('active');
        }

      });

    });

  });

}

document.addEventListener("DOMContentLoaded", initMenuTabs);
document.addEventListener("shopify:section:load", initMenuTabs);
  // ------ desktop menu accordion -----




  // custom color and prescription

  function calCustomizeTotal(productInfo){
    const custTotalEL = productInfo.querySelector(".modification-footer .price-details h2");
    const colorPrice = productInfo.querySelector(".without-prescription .add-btn.active") ? +productInfo.querySelector(".without-prescription #color-price")?.textContent.replace("Rs. ","").replace(",","") : 0;
    const presPrice = productInfo.querySelector(".with-prescription .selection-card.selected .price") ? +productInfo.querySelector(".with-prescription .selection-card.selected .price")?.textContent.replace("Rs. ","").replace(",","") : 0;
    const totalVal = colorPrice + presPrice + +custTotalEL.dataset.productPrice;
    let formattedPrice = "Rs. " + totalVal.toLocaleString('en-IN');
    custTotalEL.textContent = formattedPrice;
    if(colorPrice || presPrice ){
      productInfo.querySelector(".checkout-btn>button").removeAttribute("disabled")
    }else{
      productInfo.querySelector(".checkout-btn>button").setAttribute("disabled",true)
    }
  }
  function addCustColor(btn){
    btn.classList.toggle("active")
    const productInfo = btn.closest("product-info");
    calCustomizeTotal(productInfo)
  }
  
  function addCustPres(btn){
    btn.classList.toggle("active")
    btn.closest(".selection-card").classList.toggle("selected")
    const productInfo = btn.closest("product-info");
      calCustomizeTotal(productInfo)
  }
 
      // custom color and prescription

// -------------- pdp tabs ------------

document.addEventListener('DOMContentLoaded', () => {

  document.addEventListener("click", (e) => {

    const accordion = e.target.closest('.pdp-accordion-main');
    if (!accordion) return;

    const tab = e.target.closest('.accordion-title li');
    if (!tab) return;

    const tabs = accordion.querySelectorAll('.accordion-title li');
    const contents = accordion.querySelectorAll('.accordion-content');

    const target = tab.dataset.tab;

    tabs.forEach(t => t.classList.toggle('active', t === tab));
    contents.forEach(c =>
      c.classList.toggle('active', c.dataset.content === target)
    );

  });

});      

// -------------- pdp tabs ------------






  document.addEventListener("DOMContentLoaded",()=>{
    if(!location.pathname.includes("/search")) return;
    const searchResult = document.querySelector(".template-search--empty");
    if(searchResult){
      document.querySelector(".search-page").setAttribute("style","display:flex !important")
    }else{
      document.querySelector(".search-page").setAttribute("style","display:none !important")
    }
  })

  // ---------------mobile-menu-start------------

   function toggleMainMenu(button) {
    const menu = document.querySelector('.main-menu');
    const overlay = document.querySelector('.menu-overlay');

    if (!menu || !overlay) return;

    const isOpen = menu.classList.contains('active');

    menu.classList.toggle('active', !isOpen);
    overlay.classList.toggle('active', !isOpen);
    document.body.classList.toggle('menu-open', !isOpen);
  }

  // ---------------mobile-menu-end------------


  // ---------------mobile-menu-tabs-----------
  document.addEventListener('DOMContentLoaded', () => {
  const tabs = document.querySelectorAll('.tab-head li');
  const tabLinks = document.querySelectorAll('.tab-links');

  tabs.forEach((li, index) => {
    if (index < 2) {
      li.addEventListener('click', () => {
        tabs.forEach((tab, i) => {
          if (i < 2) {
            tab.classList.toggle('active', i === index);
          }
        });

        tabLinks.forEach((tab, i) => {
          tab.classList.toggle('active', i === index);
        });
      });
    }
  });
});
  // ---------------mobile-menu-tabs-----------

  // ---------------mobile-menu-accordion----------
  document.addEventListener('DOMContentLoaded', () => {
  const accordions = document.querySelectorAll('.menu-accordion');

  accordions.forEach((accordion) => {
    const head = accordion.querySelector('.accordion-head');
    const content = head.nextElementSibling;

    head.addEventListener('click', () => {
      const isOpen = accordion.classList.contains('active');

      accordions.forEach((item) => {
        item.classList.remove('active');
        item.querySelector('.accordion-head').classList.remove('active');
        item.querySelector('.accordion-head').nextElementSibling.style.maxHeight = '0px';
      });

      if (!isOpen) {
        accordion.classList.add('active');
        head.classList.add('active');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });
});
  // ---------------mobile-menu-accordion----------

// search-open
document.addEventListener("DOMContentLoaded", function () {
  
  const searchEl = document.querySelector('details-modal.header__search>details');
  const headerMain = document.querySelector('.header-wrapper .header');
  const headerOverlayer = document.querySelector('.search-overlayer');
  
  if (!searchEl || !headerMain) return;
  
  new MutationObserver(() => {
    const isOpen = searchEl.hasAttribute("open");
    headerMain.classList.toggle("open-search", isOpen);
    headerOverlayer.classList.toggle("active")
  }).observe(searchEl, {
    attributes: true,
    attributeFilter: ['open']
  });
  
});
// search-open